// Mock data for NA Realtors website

export const properties = [
  {
    id: 1,
    title: "Luxury Villa in Whitefield",
    location: "Whitefield, Bangalore",
    price: "₹3.5 Cr",
    bedrooms: 4,
    bathrooms: 4,
    area: "3200 sq.ft",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80",
    featured: true,
    type: "Villa"
  },
  {
    id: 2,
    title: "Modern Apartment in Koramangala",
    location: "Koramangala, Bangalore",
    price: "₹1.8 Cr",
    bedrooms: 3,
    bathrooms: 3,
    area: "1850 sq.ft",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80",
    featured: true,
    type: "Apartment"
  },
  {
    id: 3,
    title: "Penthouse with City View",
    location: "Indiranagar, Bangalore",
    price: "₹5.2 Cr",
    bedrooms: 5,
    bathrooms: 5,
    area: "4500 sq.ft",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
    featured: true,
    type: "Penthouse"
  },
  {
    id: 4,
    title: "Garden Villa in JP Nagar",
    location: "JP Nagar, Bangalore",
    price: "₹2.9 Cr",
    bedrooms: 4,
    bathrooms: 4,
    area: "3000 sq.ft",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
    featured: true,
    type: "Villa"
  },
  {
    id: 5,
    title: "Contemporary Flat in HSR Layout",
    location: "HSR Layout, Bangalore",
    price: "₹1.5 Cr",
    bedrooms: 2,
    bathrooms: 2,
    area: "1450 sq.ft",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    featured: false,
    type: "Apartment"
  },
  {
    id: 6,
    title: "Duplex House in Sarjapur",
    location: "Sarjapur Road, Bangalore",
    price: "₹4.1 Cr",
    bedrooms: 5,
    bathrooms: 5,
    area: "3800 sq.ft",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
    featured: true,
    type: "Duplex"
  }
];

export const interiorProjects = [
  {
    id: 1,
    title: "Modern Living Room Design",
    category: "Living Room",
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80",
    description: "Contemporary living space with minimalist aesthetics"
  },
  {
    id: 2,
    title: "Luxury Master Bedroom",
    category: "Bedroom",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800&q=80",
    description: "Elegant bedroom with premium finishes"
  },
  {
    id: 3,
    title: "Gourmet Kitchen Design",
    category: "Kitchen",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80",
    description: "State-of-the-art modular kitchen"
  },
  {
    id: 4,
    title: "Spa-Inspired Bathroom",
    category: "Bathroom",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80",
    description: "Luxurious bathroom with modern amenities"
  },
  {
    id: 5,
    title: "Home Office Setup",
    category: "Office",
    image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80",
    description: "Productive workspace with elegant design"
  },
  {
    id: 6,
    title: "Dining Area Transformation",
    category: "Dining",
    image: "https://images.unsplash.com/photo-1617806118233-18e1de247200?w=800&q=80",
    description: "Sophisticated dining space for entertaining"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Property Buyer",
    content: "NA Realtors helped us find our dream home. Their professionalism and attention to detail made the entire process seamless. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Interior Design Client",
    content: "The interior design team transformed our apartment into a stunning space. Their creativity and execution exceeded our expectations.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Property Seller",
    content: "Sold my property within 3 weeks at a great price. The team's market knowledge and negotiation skills are exceptional.",
    rating: 5
  },
  {
    id: 4,
    name: "Sneha Reddy",
    role: "First-time Buyer",
    content: "As a first-time buyer, I was nervous but NA Realtors guided me through every step. Couldn't have asked for better service!",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What services does NA Realtors provide?",
    answer: "We specialize in residential real estate sales, helping clients buy and sell properties. We also offer premium interior design services to transform your living spaces."
  },
  {
    id: 2,
    question: "What areas do you cover in Bangalore?",
    answer: "We cover all major areas of Bangalore including Whitefield, Koramangala, Indiranagar, HSR Layout, JP Nagar, Sarjapur Road, and surrounding areas."
  },
  {
    id: 3,
    question: "How long does it typically take to buy/sell a property?",
    answer: "The timeline varies based on market conditions and property specifics. Typically, selling a property takes 2-8 weeks, while buying can take 4-12 weeks including documentation."
  },
  {
    id: 4,
    question: "Do you charge any fees for property consultation?",
    answer: "Initial consultations are complimentary. Our commission structure is transparent and competitive, discussed upfront before engagement."
  },
  {
    id: 5,
    question: "What is included in your interior design services?",
    answer: "Our interior design services include space planning, 3D visualization, material selection, furniture procurement, execution supervision, and project management from concept to completion."
  },
  {
    id: 6,
    question: "Can I schedule a property viewing?",
    answer: "Yes! Contact us via WhatsApp at 8667644336 or call us to schedule property viewings at your convenience. We offer both in-person and virtual tours."
  },
  {
    id: 7,
    question: "Do you help with home loan arrangements?",
    answer: "Yes, we have partnerships with leading banks and financial institutions to help you secure the best home loan options with competitive interest rates."
  },
  {
    id: 8,
    question: "What documents are required to sell my property?",
    answer: "Basic documents include property title deed, tax receipts, NOC from society, encumbrance certificate, and sale agreement. We guide you through the complete documentation process."
  }
];